// maths.portll.net — narration voice preference. Mirrors lib/theme.js.
// localStorage 'mp_voice' (one of VOICES); default 'leah'. Fanned into the engine at mount time
// (MathsGame/FreePlay pass getVoice() as mount opt `voice`, consumed by DNF.voice.init).
import { useState, useEffect, useCallback } from "react";

export const VOICE_KEY = "mp_voice";
export const VOICES = [
  { value: "leah", label: "Leah", hint: "Warm · en-GB" },
  { value: "tara", label: "Tara", hint: "Bright · en-GB" },
  { value: "male1", label: "Sam", hint: "Calm · en-GB" },
];
const IDS = VOICES.map((v) => v.value);
const hasWindow = typeof window !== "undefined";

export function getVoice() {
  try {
    const v = hasWindow && window.localStorage ? window.localStorage.getItem(VOICE_KEY) : null;
    return IDS.includes(v) ? v : "leah";
  } catch {
    return "leah";
  }
}

export function setVoice(v) {
  try {
    if (hasWindow && window.localStorage) window.localStorage.setItem(VOICE_KEY, IDS.includes(v) ? v : "leah");
  } catch {
    /* storage unavailable */
  }
}

// React binding for a Settings control. Returns [voice, setChoice].
export function useVoicePref() {
  const [voice, setState] = useState(() => getVoice());
  useEffect(() => {
    setState(getVoice());
  }, []);
  const setChoice = useCallback((v) => {
    setVoice(v);
    setState(getVoice());
  }, []);
  return [voice, setChoice];
}
